import { BigNumber } from 'bignumber.js';
import { CurrencyCode, LangCode, LangItem, LANG_LIST } from '@/config/const';

import Cookies from 'js-cookie';
import { toNumber } from 'lodash';

const lang = (localStorage.getItem('lang') || Cookies.get('lang') || 'en') as LangCode;

export function keepTwoDecimals(num: number) {
  return num.toString().match(/^\d+(?:\.\d{0,2})?/);
}

export function getTimes(duration: any, unit?: boolean) {
  let secondTime: any = parseInt(duration); // 秒
  let minuteTime: any = 0; // 分
  let hourTime: any = 0; // 小时
  if (secondTime > 60) {
    minuteTime = parseInt(secondTime / 60);
    secondTime = parseInt(secondTime % 60);
    if (minuteTime > 60) {
      hourTime = parseInt(minuteTime / 60);
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  let result = '';
  // debugger;
  if (secondTime >= 0) {
    secondTime < 10 ? (result = '0' + parseInt(secondTime)) : (result = parseInt(secondTime) + '');
  }
  if (minuteTime >= 0) {
    minuteTime < 10 ? (result = '0' + parseInt(minuteTime) + result) : (result = parseInt(minuteTime) + result);
  }
  return result.split('');
}

export const thousandsComma = (num: number | string): string => {
  let Num = (num || 0).toString();
  let symbol = '';

  if (/^\+|^-/.test(Num)) {
    symbol = Num[0];
    Num = Num.substring(1);
  }

  let number = 0;
  let floatNum = '';
  let intNum = '';

  // Check for decimal places and separate them
  if (Num.includes('.')) {
    number = Num.indexOf('.');
    floatNum = Num.substring(number); // Decimal part
    intNum = Num.substring(0, number); // Integer part
  } else {
    intNum = Num;
  }

  const result: string[] = [];
  let counter = 0;

  const intNumArray = intNum.split('');
  for (let i = intNumArray.length - 1; i >= 0; i -= 1) {
    counter += 1;
    result.unshift(intNumArray[i]);
    if (counter % 3 === 0 && i !== 0) {
      result.unshift(',');
    }
  }

  return symbol + result.join('') + floatNum || '';
};

export const formatAmount = (num: number): string => {
  // 中文格式化
  function ConvertNumCN(value: number): string {
    const k = 10000;
    const sizes = ['', '万', '亿', '万亿'];
    let i: number;

    if (value < k) {
      return value.toString();
    } else {
      i = Math.floor(Math.log(value) / Math.log(k));
      return (value / Math.pow(k, i)).toFixed(2) + sizes[i];
    }
  }

  // 英文格式化
  function ConvertNumEN(value: number): string {
    const k = 1000;
    const sizes = ['', 'K', 'M', 'B'];
    let i: number;

    if (value < k) {
      return value.toString();
    } else {
      i = Math.floor(Math.log(value) / Math.log(k));
      return (value / Math.pow(k, i)).toFixed(2) + sizes[i];
    }
  }

  return lang === 'zh' || lang === 'hk' ? ConvertNumCN(num) : ConvertNumEN(num);
};

export function getFirstBit(str: string) {
  return str?.slice(0, 1);
}

export const formatVol = (total: any) => {
  if (!total) {
    return '--';
  }
  let str = '';
  const temp = Number(total);

  switch (lang) {
    case 'en':
      if (total > 1000) {
        str = (temp / 1000).toFixed(2) + 'k';
      }
      break;
    default:
      if (total > 10000) {
        str = (temp / 10000).toFixed(2) + '万';
      }
      break;
  }

  return str;
};
/** 资产类页面展示：未取到有效币种精度时的默认小数位 */
export const DEFAULT_ASSET_DISPLAY_PRECISION = 4;

function resolveAssetDisplayPrecision(configured?: number | string | null): number {
  const DEFAULT = DEFAULT_ASSET_DISPLAY_PRECISION;
  if (configured === null || configured === undefined || configured === '') {
    return DEFAULT;
  }
  const n = Number(configured);
  if (!Number.isFinite(n) || n < 0 || n > 36) {
    return DEFAULT;
  }
  return Math.min(36, Math.floor(n));
}

/** 资产展示：优先默认 {@link DEFAULT_ASSET_DISPLAY_PRECISION} 位；传入有效配置精度时则用配置（如 coinsPrecisionList[coin]） */
export const formatAssetsPrecision = (val: any, configuredPrecision?: number | string | null) => {
  const precision = resolveAssetDisplayPrecision(configuredPrecision);
  return new BigNumber(val ?? 0).toFixed(precision, 1);
};

export const telFormat = (val: any) => {
  let str = val;
  str = str.substring(0, 3) + '****' + str.substring(str.length - 4);
  return str;
};
export const emailFormat = (val: any) => {
  const email = val;
  const str = email.split('@');
  const str0 = str[0].substring(0, 3) + '****' + str[0].substring(str[0].length - 3);
  return str0 + '@' + str[1];
};
export const accountFormat = (val: any) => {
  if (val.length === 0) return '';
  // 手机号脱敏的正则表达式（这里假设手机号为11位，前3位、后4位显示，中间隐藏）
  const phoneRegex = /^(\d{3})\d+(\d{4})$/;
  if (val.includes('@')) {
    const emailStr = val.split('@');
    const start = emailStr[0][0];
    const end = emailStr[0].slice(-1);
    const stars = '*'.repeat(emailStr[0].length - 2);
    return `${start}${stars}@${emailStr[1]}`;
  }
  // 手机号脱敏
  const phoneMatch = val.match(phoneRegex);
  if (phoneMatch) {
    const [, prefix, suffix] = phoneMatch;
    const middleStars = '*'.repeat(val.length - prefix.length - suffix.length);
    return `${prefix}${middleStars}${suffix}`;
  }
};

export const getMainDomain = () => {
  const hostname = window.location.hostname; // 当前完整域名
  const parts = hostname.split('.');

  // 如果域名分段少于两个（如 localhost），直接返回 hostname
  if (parts.length < 2) return hostname;

  // 拼接主域名（最后两段）
  return `${parts.slice(-2).join('.')}`;
};

export const getTargetDomain = () => {
  const mainDomain = getMainDomain(); // 动态获取主域名
  const hostname = window.location.hostname; // 当前完整域名

  if (hostname.startsWith('www')) {
    // https://www.hashex.vip/copy/copy-trading/futures

    // return `https://copy-web.${mainDomain}`; // 从 www 跳转到 web-copy
    return `https://www.${mainDomain}`; // 从 www 跳转到 web-copy
  } else if (hostname.startsWith('copy-web')) {
    return `https://www.${mainDomain}`; // 从 web-copy 跳转到 www
  }
  return ''; // 无法判断时返回空字符串
};

export const getBillType = (arr: any[], type: string) => {
  if (!arr || arr.length == 0 || !type) {
    return '--';
  }
  return arr.filter(i => i.code == type)[0]?.value || type;
};